// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-95c4d5","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-5575f4","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-3e3d29"};